var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-info3 banner-fade-in"},[_c('div',{ref:"animate",staticClass:"banner-info3-content"},[_c('div',{staticClass:"title"},[_vm._v("Designed for you")]),_c('div',{staticClass:"desc1"},[_vm._v("Please find our rates, booking form, terms and conditions below")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }